<template>
  <div class="payroll">
    <p>Run Payroll</p>
    <div class="payroll__div">
      <div class="payroll__content">
        <div class="center-content">
          <div class="btn-container">
            <p class="payroll_header_text">Setup Your Payroll</p>
          </div>
        </div>

        <div class="payroll__preview--warning">
          <div class="payroll__breakdown--alert-text-icon">
            <img src="./../../../assets/images/info.png" alt />
          </div>
          <div class="payroll__breakdown--alert-text-para">
            You can initiate payment after setting up this payroll.
          </div>
        </div>

        <div class="payroll--title">
          <label for="">Payroll Title</label>
        </div>
        <div class="payroll__content--header-input">
          <div>
            <input v-model="title" placeholder="e.g Payroll for only engineers" type="text" class="form-control"
              autofocus />
          </div>
        </div>

        <div class="payroll__content--header-select">
          <select v-model="selectedMonth">
            <option v-for="item in months" v-bind:key="item.index" :value="item">
              {{ item }} {{ year }}
            </option>
          </select>
        </div>

        <p class="payroll__content--paragraph-text" v-if="loading">
          Fetching payroll details...wait a minute
        </p>
        <p v-if="!loading" class="payroll__content--paragraph-text">
          Your payroll will auto run on - {{ paymentDate }} {{ selectedMonth }},
          {{ year }}
          <br />
          <span class="change-date" @click="showPayrollSetting">change date</span>
        </p>

        <div class="center-content">
          <div class="hrdesk__client btn-container">
            <div @click="nextStage" class="button-41" v-if="!loading">
              <div>Proceed</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";

export default {
  name: "RunPayroll",
  data() {
    return {
      months: "",
      selectedMonth: "",
      title: "",
      paymentDate: "",
      year: "",
      loading: true,
      manager: 1,
    };
  },
  created() {
    this.months = [
      "January",
      "Febuary",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let title = this.$router.currentRoute.query.title;
    let month = this.$router.currentRoute.query.month;
    let year = this.$router.currentRoute.query.year;

    if (title) {
      this.title = title;
    }
    if (month) {
      this.selectedMonth = month;
      this.loading = false;
    } else {
      this.getPayrollDate();
    }
    if (year) {
      this.year = year;
    }
  },
  methods: {
    showPayrollSetting() {
      this.$store.showCompanySetting = "payroll";
      this.$router.push("/settings");
    },
    getPayrollDate() {
      const companyId =
        this.$store.getters.currentAuthUser.employees.company_id;
      this.$http.get(`${types.COMPANY_GET_API}/${companyId}`).then((resp) => {
        const date = new Date();

        const dateValue = date.getMonth();
        this.selectedMonth = this.months[dateValue];
        this.year = date.getFullYear();

        this.$store.state.payrollMonth = this.selectedMonth;
        this.$store.state.payrollYear = this.year;

        this.paymentDate = resp.data.data.payroll_month;
        this.$store.state.payrollDate = resp.data.data.payroll_month;
        this.loading = false;
      });
    },
    nextStage() {
      this.$store.state.payrollMonth = this.selectedMonth;
      this.$store.state.payrollYear = this.year;
      this.$store.state.payrollTitle = this.title;
      this.$store.state.payrollDay = this.paymentDate;

      this.$router.push({ name: "processPayroll" });
    },
  },
};
</script>

<style lang="scss" scoped>
.payroll {
  padding-top: 5rem;

  >p {
    font-size: 2.083rem;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.18;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    margin: 0;
    padding-left: 1rem;

    @media (max-width: 768px) {
      font-size: 1.7rem;
  }
  }

  >.payroll__div {
    border-top: 1px solid #caced5;
  }

  @media (max-width: 768px) {
    padding: 1rem;
    margin-top: 2rem;
  }
}

.payroll_header_image {
  width: 30px;
  object-fit: contain;
  margin: 0 auto 36px auto;
}

.payroll_header_text {
  font-size: 1.4rem;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.payroll--title {
  width: 50%;
  font-size: 1.042rem;
  margin: 0 auto;
  text-align: justify;
  margin-bottom: 0px !important;
  margin-top: 40px;
  @media (max-width: 768px) {
    width: 90%;

  }
}


.change-date {
  text-decoration: underline;
  color: #5099de;
  cursor: pointer;
}


.payroll__content {
  width: 40.521rem;
  margin: 46px auto 0 auto;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 25px;
  padding-bottom: 54px;
  text-align: center;

  @media (max-width: 768px) {
    width: 20.521rem;
  }

  .payroll__content--header-text {
    font-size: 2.083rem;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
  }

  >.payroll__content--header-input {
    width: 20rem;
    height: 40px;
    margin: 0 auto;
    border-radius: 5px;
    overflow: hidden;

    >select {
      height: 10rem;
      border: 0;
      outline: 0;
      font-size: 1.042vw;
    }
    @media (max-width: 768px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  }

  >.payroll__content--header-select {
    width: 20rem;
    height: 40px;
    margin: 20px auto 0 auto;
    border: 1px solid #ccc;
    overflow: hidden;
    border-radius: 5px;

    >select {
      height: 40px;
      border: 0;
      outline: 0;
    }
    
    @media (max-width: 768px) {
    width: 88%;
  }
  }

  >.payroll__content--paragraph-text {
    font-size: 1rem;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: center;
    color: #e57413;
    margin-top: 10px;

    >span {
      font-weight: 600;
    }
    @media (max-width: 768px) {
    padding: 1rem;
  }
  }

  >.hrdesk__client {
    >.payroll__content--button {
      width: 13.021rem;
      height: 52px;
      border-radius: 5px;
      background-color: #5099de;
      margin: 0 auto;
      font-size: 0.938rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.22;
      letter-spacing: normal;
      text-align: center;
      cursor: pointer;

      >a {
        color: #fff;
        text-decoration: none;

        >div {
          height: 52px;
          color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }
      }
    }
  }
}

.button-41 {
  background: #5099de;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-family: Inter, -apple-system, system-ui, Roboto, "Helvetica Neue", Arial,
    sans-serif;
  height: 44px;
  line-height: 44px;
  outline: 0;
  overflow: hidden;
  padding: 0 20px;
  pointer-events: auto;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 100%;
  z-index: 9;
  border: 0;
}

.button-41:hover {
  background: #004262;
}

.btn-container {
  width: 15rem;
  margin: 1rem;
  display: flex;
  justify-content: center;
}

.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.payroll__content--options {
  margin-top: 8rem;
  margin-bottom: 300px;

  >p {
    font-size: 1.458rem;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    margin: 0;
  }

  >div {
    border-top: 1px solid #caced5;
    padding-top: 60px;

    >.payroll__content--options-otp {
      width: 281.3px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      padding: 19px 61px 46px 27px;
      text-align: left;

      >div {
        width: 1.458rem;
        object-fit: contain;
      }

      >h3 {
        font-size: 1.25rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      >span {
        font-size: 0.938rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        text-align: left;
        color: #707070;
      }

      >p {
        margin-top: 69px;
        font-size: 0.938rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.22;
        letter-spacing: normal;
        text-align: left;
        color: #5099de;
        cursor: pointer;

        >a {
          color: #5099de;
          text-decoration: none;
        }

        &:hover {
          color: rgba(80, 153, 222, 0.5);
        }
      }
    }
  }
}

.payroll__preview--warning {
  border-radius: 3px;
  /* -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16); */
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
  border: solid 2px #a4caee;
  background-color: #5099dd33;
  padding: 12px 1.615vw;
  width: 80%;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 15px;

  .payroll__breakdown--alert-text-icon {
    width: 2.396rem;
    float: left;
  }

  .payroll__breakdown--alert-text-para {
    width: calc(100% - 2.396rem);
    padding-left: 1.042rem;
    float: left;
    font-size: 0.938rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.22;
    letter-spacing: normal;
    text-align: left;
    color: #5099de;
  }
}
</style>
